import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IExtra extends IBaseEntity {
    id?: number;
    jobId?: number; // when this is populated orderId is null
    extraTypeId?: number;
    customDescription?: string;
    clientContact?: string;
    extraAmount?: number;
    substituteJobId?: number;
    orderId?: number; // when this is populated orderId is null
    foreignAmount?: number;
    exchangeRateId?: number;
    siteVisitSubContractId?: number;
    fuelSurchargeAmount?: number;
    included?: boolean;
    fuelSurchargeForeignAmount?: number;
    fuelSurchargeApplies?: boolean;
    quantity?: number;
    invoiceId?: number;
    customerCurrency?: any;
    state?: string;
    note?: string;
    chargeable?: boolean;
    showOnVehicleRevenueReports?: boolean;
}

export class Extra extends BaseEntity implements IExtra {
    public id?: number;
    public jobId?: number;
    public extraTypeId?: number;
    public customDescription?: string;
    public clientContact?: string;
    public extraAmount?: number;
    public substituteJobId?: number;
    public orderId?: number;
    public foreignAmount?: number;
    public exchangeRateId?: number;
    public siteVisitSubContractId?: number;
    public fuelSurchargeAmount?: number;
    public fuelSurchargeForeignAmount?: number;
    public included?: boolean;
    public fuelSurchargeApplies?: boolean;
    public quantity?: number;
    public customerCurrency?: any;
    public invoiceId?: number;
    public state?: string;
    public note?: string;
    public chargeable?: boolean;
    public showOnVehicleRevenueReports?: boolean;

    constructor(extra?: any) {
        super();
        if (extra) {
            this.id = extra.id;
            this.jobId = extra.jobId;
            this.extraTypeId = extra.extraTypeId;
            this.customDescription = extra.customDescription;
            this.clientContact = extra.clientContact;
            this.extraAmount = extra.extraAmount;
            this.substituteJobId = extra.substituteJobId;
            this.orderId = extra.orderId;
            this.foreignAmount = extra.foreignAmount;
            this.exchangeRateId = extra.exchangeRateId;
            this.siteVisitSubContractId = extra.siteVisitSubContractId;
            this.fuelSurchargeAmount = extra.fuelSurchargeAmount;
            this.fuelSurchargeForeignAmount = extra.fuelSurchargeForeignAmount;
            this.included = true;
            this.fuelSurchargeApplies = extra.fuelSurchargeApplies;
            this.quantity = extra.quantity;
            this.customerCurrency = extra.customerCurrency;
            this.invoiceId = extra.invoiceId;
            this.state = extra.state;
            this.note = extra.note;
            this.chargeable = extra.chargeable ?? true;
            this.showOnVehicleRevenueReports = extra.showOnVehicleRevenueReports ?? true;
        }
    }

    get discriminator(): any {
        return this.customDescription;
    }

    clone(): Extra {
        return new Extra(this);
    }
}
